export default {
  PROJECT: 'project',
  PHOTO: 'photo',
  VIDEO: 'video',
};
